type Link = {
  name: string;
  action: string;
  url?: string;
  userRight?: string;
  path?: string;
};

type MenuItem = {
  header: string;
  links: Link[];
  icon: string;
  userRight?: string;
};

type Env = "prod" | "sandbox";

const trimSlash = (s: string) => s.replace(/\/+$/, "");

function getEnvFromUrl(): Env {
  const host =
    typeof window !== "undefined" && window.location?.hostname
      ? window.location.hostname.toLowerCase()
      : "";

  // If your sandbox URL contains "sandbox" / "staging" / etc.
  if (host.includes("sandbox")) {
    return "sandbox";
  }

  return "prod";
}

const DATA_HOST = trimSlash(
  getEnvFromUrl() === "sandbox"
    ? "https://data.sandbox.westernbulk.cloud"
    : "https://data.prod.westernbulk.cloud"
);

const NAVILEXT_HOST = trimSlash(
  getEnvFromUrl() === "sandbox"
    ? "https://sandbox.navi-lex.com"
    : "https://prod.navi-lex.com"
);

// reuse base paths
const WB_WEBPAGES = `${DATA_HOST}/wb-webpages/src/main.html?page=`;
const NAVILEX_PAGE = (page: string) =>
  `${NAVILEXT_HOST}/?page=${encodeURIComponent(page)}`;

export const sidebarLinks: MenuItem[] = [
  {
    header: "TONNAGE",
    icon: "bi bi-life-preserver",
    links: [
      {
        name: "-VESSELVIEW",
        action: "link",
        url: `${WB_WEBPAGES}vessel_view`,
      },
    ],
  },
  {
    header: "WEATHER",
    icon: "bi bi-cloud-sun",
    links: [
      {
        name: "-PORTS",
        action: "link",
        url: `${WB_WEBPAGES}weather_in_ports`,
      },
      {
        name: "-SEA MARGIN",
        action: "link",
        url: `${WB_WEBPAGES}sea_margin`,
      },
    ],
  },
  {
    header: "EMISSIONS",
    icon: "bi bi-thermometer",
    links: [
      {
        name: "-VOYAGE CO2",
        action: "link",
        url: `${WB_WEBPAGES}emission_report`,
      },
      {
        name: "-EU REPORTS",
        action: "eu-ets-report",
      },
    ],
  },
  {
    header: "TRADES",
    userRight: "tradeRecap",
    icon: "bi bi-currency-dollar",
    links: [
      {
        name: "-EXTERNAL TRADES",
        action: "link",
        url: `${WB_WEBPAGES}external_trades`,
      },
      {
        name: "-INTERNAL TRADES",
        action: "link",
        url: `${WB_WEBPAGES}internal_trades`,
      },
      {
        name: "-HISTORY",
        action: "link",
        url: `${WB_WEBPAGES}history_trades`,
      },
    ],
  },
  {
    header: "VENTURA",
    icon: "bi bi-clipboard-data-fill",
    links: [
      {
        name: "-PORT DATA",
        action: "ventura-port",
      },
      // {
      //   name: "-VENTURA UPDATED",
      //   action: "ventura-updated",
      // },
    ],
  },
  {
    userRight: "navilex-admin",
    header: "ADMIN",
    icon: "bi bi-gear",
    links: [
      //{ name: "-CONTRACT TYPES", action: "contract-admin",userRight:"navilex-admin" },
      { name: "-TOKEN", action: "token", userRight: "navilex-admin-token" },
    ],
  },
  {
    header: "ANALYTICS",
    icon: "bi bi-bar-chart-line",
    links: [
      {
        name: "-TEAM ESTIMATES",
        action: "link",
        url: `${WB_WEBPAGES}team_estimates`,
      },
      // Additional links
    ],
  },
  {
    header: "OFFICE TOOLS",
    userRight: "businessCard",
    icon: "bi bi-card-list",
    links: [
      {
        name: "-BUSINESS CARD",
        action: "link",
        url: `${WB_WEBPAGES}business_card`,
      },
      // Additional links
    ],
  },
  {
    header: "NAVILEX AI",
    icon: "bi bi-journal-bookmark-fill",
    links: [
      {
        name: "-NEW CONTRACT",
        action: "link",
        url: NAVILEX_PAGE("new-contract"),
      },
      {
        name: "-CONTRACT HISTORY",
        action: "link",
        url: NAVILEX_PAGE("workflows"),
      },
    ],
  },
  {
    header: "FDTR",
    userRight: "tradeRecap",
    icon: "bi bi-infinity",
    links: [
      { name: "-OVERVIEW", action: "ffa-overview" },
      {
        name: "-SEASONALITY",
        action: "seasonality",
      },
      { name: "-TREND SIGNAL", action: "trend-signal" },
    ],
  },
  // Add more sections as needed
];
